var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.50319 0.531144C0.825479 0.191053 1.26254 0 1.71826 0C2.17397 0 2.61103 0.191053 2.93332 0.531144L9.01038 6.94581L15.0874 0.531144C15.4116 0.200691 15.8457 0.0178398 16.2963 0.0219731C16.7469 0.0261064 17.178 0.216894 17.4966 0.553243C17.8153 0.889592 17.996 1.34459 17.9999 1.82024C18.0039 2.2959 17.8306 2.75414 17.5176 3.09629L11.4405 9.51095L17.5176 15.9256C17.8306 16.2678 18.0039 16.726 17.9999 17.2017C17.996 17.6773 17.8153 18.1323 17.4966 18.4687C17.178 18.805 16.7469 18.9958 16.2963 18.9999C15.8457 19.0041 15.4116 18.8212 15.0874 18.4908L9.01038 12.0761L2.93332 18.4908C2.60919 18.8212 2.17506 19.0041 1.72444 18.9999C1.27382 18.9958 0.842772 18.805 0.524125 18.4687C0.205478 18.1323 0.0247324 17.6773 0.0208166 17.2017C0.0169009 16.726 0.190128 16.2678 0.50319 15.9256L6.58024 9.51095L0.50319 3.09629C0.180997 2.75609 0 2.29475 0 1.81371C0 1.33268 0.180997 0.871339 0.50319 0.531144Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseicon);
export default __webpack_public_path__ + "static/media/closeicon.0e289f06.svg";
export { ForwardRef as ReactComponent };